// Konfiguracja tabeli „Dokumenty finansowe” na karcie klienta (Panel Handlowca)

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Parametry (opcje nad tabelą) – brak
 */
export const getTraderClientCardDocumentsTableParameters = (
): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: numer oferty, data oferty, wartość (zł)
 */
export const getTraderClientCardDocumentsTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'text',
      label: t('Numer'),
      field_symbol: 'document_symbol',
      align: 'left',
      tooltip: null,
      size: 160
    },
    {
      type: 'text',
      label: t('Data oferty'),
      field_symbol: 'create_date',
      align: 'center',
      tooltip: null,
      size: 140
    },
    {
      type: 'text',
      label: t('Wartość netto (zł)'),
      field_symbol: 'value_net_formatted',
      align: 'right',
      tooltip: null,
      size: 140
    },
  ];
};

/**
 * Akcje tabeli – brak
 */
export const getTraderClientCardDocumentsTableActions = (
): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych (endpoint /sales-crm/clients/:clientId/documents)
 */
export const traderClientCardDocumentsTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/:clientId/documents',
  params_list: null
};
